import { DndContext, DragOverlay } from '@dnd-kit/core';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import {
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { type RelationEditor } from '@framework/form/form/relations/useRelationEditor.ts';
import { useBasicDndDragger } from '@framework/ui/core/dnd/hooks/useBasicDndDragger.ts';
import { Typography } from 'antd';
import { useWatch } from 'react-hook-form';
import { type IMapGroup } from '../layers/MapGroup.ts';
import { type IMapLayer, type MapLayerType } from '../layers/MapLayer.ts';
import { MapLayerConfigDrawerButton } from './MapLayerConfigDrawerButton.tsx';
import { MapLayerItem } from './MapLayerItem.tsx';
import { MapLayerSortableItem } from './MapLayerSortableItem.tsx';

export interface IMapLayersConfigSectionProps {
  editor: RelationEditor<IMapLayer>;
  allowedTypes?: MapLayerType[];
}

export function MapLayersConfigSection(props: IMapLayersConfigSectionProps) {
  const { editor } = props;
  const { sensors, handleDragStart, handleDragEnd, itemIds, active } =
    useBasicDndDragger(editor);
  const groups: IMapGroup[] = useWatch({ name: 'groups' }) ?? [];

  return (
    <div>
      <Typography.Paragraph>
        Il livello che appare per primo è quello più in alto, ovvero il livello
        in <b>primo piano</b>.
      </Typography.Paragraph>
      <DndContext
        sensors={sensors}
        onDragStart={handleDragStart}
        onDragEnd={handleDragEnd}
        modifiers={[restrictToVerticalAxis]}
      >
        <SortableContext items={itemIds} strategy={verticalListSortingStrategy}>
          {editor.items.map((item, i) => (
            <MapLayerSortableItem
              index={item.__uid!}
              key={item.__uid}
              layer={item}
              configMode
              onEdit={e => {
                e.preventDefault();
                e.stopPropagation();

                editor.handle.open(item);
              }}
              onRemove={e => {
                e.preventDefault();
                e.stopPropagation();
                editor.removeAt(i);
              }}
            />
          ))}

          <DragOverlay>
            {active && <MapLayerItem layer={active} isDragging />}
          </DragOverlay>
        </SortableContext>
      </DndContext>
      <MapLayerConfigDrawerButton
        editor={editor}
        allowedTypes={props.allowedTypes}
        groups={groups}
      />
    </div>
  );
}
